import CanvasHtmlElement from "./CanvasHtmlElement";
import CanvasControls from "./CanvasControls";
import CanvasScrollLock from "./CanvasScrollLock";

export default {
  CanvasHtmlElement,
  CanvasControls,
  CanvasScrollLock,
};
